export const en = {
  received: 'Payment Received',
};

export const ar: typeof en = {
  received: 'تم استلام المبلغ',
};
